<template>
    <section class="page-content">
        <TopBackgroundComponent/>
        <CareerTopComponent/>
    </section>
</template>

<script setup>
    import TopBackgroundComponent from '../components/TopBackgroundComponent.vue';
    import CareerTopComponent from '@/components/career/CareerTopComponent.vue';
    window.scrollTo(0, 0);
</script>

<style scoped>
    /*  */
</style>